import Phaser from 'phaser';
// Import any other assets or utilities as needed

import BaseSoupGameScene from './BaseSoupGameScene';

import { createGameLevels, createImage } from './GameFunctions';
import { gameAssets } from './LevelsConfig';

export default class KitchenScene extends BaseSoupGameScene {

    //create const for name
    name = "KitchenScene";

    constructor() {
        super('KitchenScene');

        this.resizeGame = this.resizeGame.bind(this);
    }

    preload() {
        super.preload();
    }

    async create() {
        super.create();
        console.log('KitchenScene create');


        

        // Initialization code here
        let game = this.game;
        game.loop.actualFps = 30;

        this.gameObjects = await createGameLevels(this, game, this.name);

        //hide faucetWater
        let faucetWater = this.gameObjects.find(item => item.id === "faucetWater.apng");
        let waterInitalScale = faucetWater.scale;
        faucetWater.scale = 0.0;
        setTimeout(() => {
            faucetWater.scale = waterInitalScale;
            faucetWater.alpha = 0;
        }, 2000);
        

        //listen for spineEvent on window and if its eName is complete and the animationName is washHandsSpine
        //then hide the faucetWater.apng object
        window.addEventListener('spineEvent', (event) => {
            let faucetWater = this.gameObjects.find(item => item.id === "faucetWater.apng");
            let sinkWater = this.gameObjects.find(item => item.id === "sinkWater");

            if (event.detail.eName === "start" && event.detail.id === "washHandsSpine" && event.detail.animationName === "wash") {
                //faucetWater?.setVisible(true);
                //fade in the faucetWater.apng object
                //if faucetWater alpha is 0 then fade in
                if (faucetWater.alpha === 0) {
                    this.tweens.add({
                        targets: [sinkWater, faucetWater],
                        alpha: 1,
                        duration: 500,
                        ease: 'Linear'
                    });
                }
            }
            if (event.detail.eName === "complete" && event.detail.id === "washHandsSpine" && event.detail.animationName === "wash") {
                //faucetWater?.setVisible(false);
                //fade out the faucetWater.apng object
                this.tweens.add({
                    targets: [sinkWater, faucetWater],
                    alpha: 0,
                    duration: 500,
                    ease: 'Linear'
                });
            }
        });





        // window.addEventListener('resize', this.resizeGame);
        // this.scale.on('resize', function (gameSize, baseSize, displaySize, resolution) {
        //     let width = gameSize.width;
        //     let height = gameSize.height;

        //     // Scale your game objects here
        //     // For example, if you have a sprite called player:
        //     //this.player.setScale(width / this.game.config.width, height / this.game.config.height);

        //     //loop through all game objects and scale them
        //     debugger
        //     this.gameObjects.forEach((gameObject) => {
        //         gameObject.setScale(width / this.scale.width, height / this.scale.height);
        //     });
        // }, this);

        //find the game object potEmptyHot
        let potEmptyHot = this.gameObjects.find(item => item.id === "potEmptyHot");

        let knife = this.gameObjects.find(item => item.id === "knife");
        knife.setInteractive(new Phaser.Geom.Rectangle(0, 0, knife.width, knife.height), Phaser.Geom.Rectangle.Contains);
        

        //test smoke
        // Assuming you have a Phaser game instance created
        // Create a Particle Emitter Manager
        //let line = new Phaser.Geom.Line(potEmptyHot.x + 75, potEmptyHot.y + (1000 * potEmptyHot.scale), potEmptyHot.x + (potEmptyHot.width * potEmptyHot.scale) - 75, potEmptyHot.y + (1000 * potEmptyHot.scale));
        let ellipse = new Phaser.Geom.Ellipse(1028, 438, 220, 50);
        
        //draw the ellipse
        // let steamEllipse = this.add.graphics({ fillStyle: { color: 0x0000ff } });
        // steamEllipse.fillEllipse(ellipse.x, ellipse.y, ellipse.width, ellipse.height);
        // steamEllipse.setInteractive(ellipse, Phaser.Geom.Ellipse.Contains);
        // this.input.setDraggable(steamEllipse);

        //load the smoke image
        await this.loadImage('smoke');
        let smoke = this.add.particles(0, 0,'smoke',{
            emitZone: { type: 'random', source: ellipse },
            angle: { min: -95, max: -85 },
            speed: { min: 10, max: 20 }, // Increase speed for more noticeable upward movement
            scale: { start: 0.05, end: 0.3 }, // Start smaller and expand
            alpha: { start: 0.1, end: 0 }, // More subtle
            blendMode: 'SCREEN',
            lifespan: 2000, // Longer lifespan,
        });

        // Add vertical movement to the particles
        this.time.addEvent({
            loop: true,
            delay: 50,
            callback: () => {
                smoke.forEachAlive(particle => {
                    particle.y -= 2; // Move each particle up slightly
                    particle.x += Math.sin(particle.lifeT * 0.01); // Add horizontal wavy movement
                });
            }
        });
        
        this.game.events.emit('phaserScenePreloadEnd');

        //this.preloadOtherScenes();
    }

    preloadOtherScenes() {
        // Boot the other scenes without displaying them
        this.scene.run('CookingScene');
        //this.scene.stop('CookingScene');

        this.scene.run('MyPlateScene');
        //this.scene.stop('MyPlateScene');

        setTimeout(() => {
            try {
                this.scene.stop('CookingScene');
                this.scene.stop('MyPlateScene');
            } catch (error) {
                console.error('Error in preloadOtherScenes:', error);

            }
        }, 1000);

        // Optionally, notify when the scenes are preloaded
        console.log('Other scenes preloaded.');
    }

    handleStepChange(currentLevel, currentLevelData, currentStep, currentStepData) {    
        super.handleStepChange(currentLevel, currentLevelData, currentStep, currentStepData);


        // React to the step change
        //console.log('KitchenScene handleStepChange:', currentLevel, currentLevelData, currentStep, currentStepData);
    }

    resizeGame() {
        // Debounce logic using a timeout
        if (this.resizeTimeout) {
            clearTimeout(this.resizeTimeout);
        }

        // Set a new timeout to handle the final resize event
        this.resizeTimeout = setTimeout(() => {
            // Reset the timeout
            this.resizeTimeout = null;

            // Get the new window dimensions
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;

            // Resize the game camera
            this.cameras.resize(windowWidth, windowHeight);

            // Restart the scene (optional, only if necessary)
            this.scene.restart();

            console.log('Game resized to:', windowWidth, windowHeight);
        }, 250); // Adjust the delay as needed (250ms is common for debouncing)
    }

    resize(gameSize, baseSize, displaySize, resolution) {
        super.resize(gameSize, baseSize, displaySize, resolution);
        const { width, height } = gameSize;
        this.cameras.resize(width, height);

        // Adjust your game objects here if needed
    }

    shutdown() {
        super.shutdown();
        console.log('KitchenScene shutdown');
        window.removeEventListener('resize', this.resizeGame);

        // Stop all active tweens
        this.tweens.killAll();
    }

    destroy() {
        super.destroy();
        // Optional: Also stop tweens in the destroy method if needed
        this.tweens.killAll();



        //loop through all game objects and call destroy if it exists
        //also call this.tweens.killTweensOf(item) if it exists
        this.gameObjects.forEach(item => {
            if (this.tweens.killTweensOf) {
                this.tweens.killTweensOf(item);
            }
            if (item.destroy) {
                item.destroy();
            }
        });
    }

    // Add any additional methods or helpers needed for the scene

    


}
